import topDashboard from "@/views/dashboard/top/top.vue";
import dailyDashboard from "@/views/dashboard/daily/daily.vue";
import {
    getOverview,
    getStudentReportUsergroup
} from "@/service/dashboard/dashboard";
export default {
    props: {
        sendOverview: {
            type: Object,
        }
    },
    components: {
        topDashboard,
        dailyDashboard,
    },
    mounted() {
        this.initialize();
    },

    data() {
        return {
            main_data: {
                allCourse: 0,
                allStudent: 0,
                onlineCourseToday: 0,
                allMedia: 0,
                arrayMedia: {
                    video: 0,
                    pdf: 0,
                    exam: 0,
                    book: 0,
                    file: 0,
                    image: 0,
                    blog: 0,
                    url: 0,
                    youtube: 0,
                },
                arraySkill: []
            },
            arraySkillNew: [],
            arrayGroup: [],
            dataGroup: [],
            userGroupSearch: [],
            dataGroupSelect: {},
            isGroupNull: false,
        }
    },
    watch: {
        dataGroupSelect(val) {
            this.$emit("sendDataGroupSelect", val, this.isGroupNull);
        },
        sendOverview(value) {
            this.sendOverview = value
            console.log(123456)
            this.initialize()
        },
    },
    methods: {
        async initialize() {
            let result = this.sendOverview.resultOverview;
            await this.getUserGroupList()
            this.main_data = result
        },
        async getUserGroupList() {
            let result = this.sendOverview.dataGroup;

            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            this.arrayGroup.push({
                _id: '',
                title: 'ไม่มีกลุ่ม'
            });
            if (result) {
                await result.forEach(async (group) => {
                    // let arrayGroup = []
                    group.child_User_Group.length === 0
                        ? await this.arrayGroup.push({
                            title: group.title,
                            _id: group._id,
                        })
                        : null;
                    group.child_User_Group.forEach(async (child) => {
                        child.child_User_Group.length === 0
                            ? await this.arrayGroup.push({
                                title: group.title + " -> " + child.title,
                                _id: child._id,
                            })
                            : null;
                        child.child_User_Group.forEach(async (lastChild) => {
                            await this.arrayGroup.push({
                                title: group.title + " -> " + child.title + " -> " + lastChild.title,
                                _id: lastChild._id,
                            });
                        });
                    });
                    // await userGroupAllAtIndex.push({arrayGroup})
                });
            }

            // console.log(this.arrayGroup);
            this.groupUsers = result;
            await this.arrayGroup.filter((group) => group.active === true);
            // this.filterGroupResult = result;
        },
        async applyFilter() {
            let group = this.userGroupSearch;
            let arraySetGroup = [];
            this.isGroupNull = false;
            for (let index = 0; index < group.length; index++) {
                if (group[index]._id != '') {
                    arraySetGroup.push(group[index]._id);
                } else {
                    this.isGroupNull = true;
                }              
            }
            this.dataGroupSelect = arraySetGroup
            this.main_data = []
            let resultOverview = await getOverview({usergroup: arraySetGroup, groupnull: this.isGroupNull});
            console.log(resultOverview)

            this.main_data = resultOverview

        }
    }
}